<template>
  <q-pull-to-refresh @refresh="refresh">
    <q-card flat>
      <q-card-section
          :class="!$q.screen.lt.md?(!adminView?'no-padding fixed z-fab full-width':'no-padding full-width'):'no-padding full-width'"
          v-if="$store.state.roles.some(v=>['admin','can_sea_order_trace', 'user_visitor'].includes(v))">
        <q-toolbar class="bg-blue text-white"
                   v-if="$store.state.roles.some(v=>['admin','can_sea_order_trace', 'user_visitor'].includes(v))">
          <q-input color="black" style="width: 100%" bg-color="white" type="search"
                   label="رهگیری سفارشات فروش..."
                   v-model="searchKey" filled dense>
            <template v-slot:append>
              <q-btn round flat icon="filter_alt" @click="showFilterDialog" :color="filterButtonColor">
                <q-tooltip>
                  فیلتر نمودن اطلاعات
                </q-tooltip>
              </q-btn>
              <q-btn color="primary" flat round icon="settings"
                     v-if="$store.state.roles.some(v=>['admin','can_sea_order_trace'].includes(v))">
                <q-popup-proxy>
                  <q-card flat>
                    <q-card-section>
                      <q-toggle color="red" v-model="archive" label="مشاهده سفارشات آرشیو شده"/>
                      <q-space/>
                      <q-toggle v-model="needForDelete" color="red"
                                label="مشاهده درخواست های حذف"/>
                      <q-space/>
                      <q-toggle v-model="expired" color="red" label="مشاهده سفارشات منقضی"/>
                    </q-card-section>
                  </q-card>
                </q-popup-proxy>
              </q-btn>
            </template>
            <template v-slot:prepend>
              <q-avatar size="md" color="teal" text-color="white" icon="search"/>
            </template>
          </q-input>
          <q-space/>
        </q-toolbar>
        <q-linear-progress
            v-if="totalSalesInfo &&
            totalSalesInfo.salePrice && totalSalesInfo.salePrice>0 && $store.state.roles.some(v=>['admin','can_sea_order_trace'].includes(v))"
            size="30px"
            :value="totalSalesInfo.Sale_Pay===0 || totalSalesInfo.salePrice===0?0: (totalSalesInfo.Sale_Pay/totalSalesInfo.salePrice)"
            color="red" reverse track-color="blue-grey">
          <div class="absolute-full flex flex-center" dir="ltr">
            <q-badge
                v-if="!$q.screen.lt.md && $store.state.roles.some(v=>['admin','can_see_total_sale_in_order_trace_sale'].includes(v))"
                color="purple" text-color="white" class="text-subtitle2"
                :label="`${totalSalesInfo.Sale_Pay.toLocaleString()} / ${totalSalesInfo.salePrice.toLocaleString()}`"/>
            <q-badge color="white" text-color="accent" class="text-subtitle2 q-ml-xs"
                     :label="`(${(totalSalesInfo.Sale_Pay===0 || totalSalesInfo.salePrice===0?0:Math.abs(totalSalesInfo.Sale_Pay / totalSalesInfo.salePrice  ) * 100).toFixed(2)}%)`"/>
          </div>
          <q-tooltip content-class="bg-transparent" v-if="$q.screen.lt.md">
            <q-chip
                size="lg"
                :label="`${totalSalesInfo.salePrice.toLocaleString()} / ${totalSalesInfo.Sale_Pay.toLocaleString()}`"
                color="red" text-color="white"
            />
          </q-tooltip>
        </q-linear-progress>
      </q-card-section>
      <q-card-section
          :style="$q.screen.lt.md?'':(($store.state.roles.some(v=>['user_visitor'].includes(v)))?!adminView?'top:30px':'':(!adminView?'top:70px':''))">
        <Summary :items="summary"
                 @city-selected="citySelected"
                 :velocity-items="sale_velocity"
                 :total-sale="totalSalesInfo.Sale_Pay"
                 :new-customer-list="newCustomerList"/>
      </q-card-section>

      <q-card-section
          :style="$q.screen.lt.md?'':(adminView?'top:-15px':'top:50px')"
          class="no-padding">
        <q-tabs
            v-model="tab"
            class="bg-indigo text-white"
            align="justify"
            narrow-indicator
            no-caps
            inline-label
        >
          <q-tab name="order"
                 v-if="$store.state.roles.some(v=>['admin','can_sea_order_trace','user_visitor'].includes(v))"
                 icon="shopping_basket" label="فروش">
            <q-badge color="red" floating>
              {{
                order_sale_statOptions.length + order_sale_state_managerOptions.length + before_stock_clerkOptions.length
              }}
            </q-badge>
          </q-tab>
          <q-tab name="store" icon="store" label="انبار">
            <q-badge color="red" floating>
              {{
                stock_clerkOptions.filter(item => item.Co > 0).length +
                stock_clerkOptions.filter(item => item.Co === 0 && !item.Visitor_Name && item.Sale_Kind === 1).length +
                stock_clerkOptions.filter(item => item.Co === 0 && item.Visitor_Name && item.Sale_Kind === 1).length
              }}
            </q-badge>
          </q-tab>
          <q-tab name="factor" icon="real_estate_agent" label="تحویل/دریافت کالا">
            <q-badge color="red" floating>
              {{
                $store.state.roles.some(v => ['admin', 'can_sea_order_trace', 'user_visitor'].includes(v)) ?
                    order_exitOptions.length + wayBillOptions.length + factorListOptions.length : order_exitOptions.length + wayBillOptions.length
              }}
            </q-badge>
          </q-tab>
        </q-tabs>

        <q-separator spaced
                     v-if="$store.state.roles.some(v=>['admin','can_sea_order_trace','user_visitor'].includes(v))"/>

        <q-tab-panels v-model="tab" animated class="bg-indigo-1 text-center">
          <q-tab-panel name="order" class="no-padding">
            <q-card flat>
              <q-card-section :horizontal="!$q.screen.lt.md" class="no-padding text-left">
                <BuyList :items="buyRequestList"
                         title="درخواست های خرید"
                         :compact-view="true"
                         :read-only="true"
                         :filter="searchKey"
                         :no-price="true"
                         :no-order-info="true"
                         v-if="$store.state.roles.some(v=>['user_sell','admin','salemanager'].includes(v))"
                         :is-dialog="false"
                         @sale-order-created=saleOrderCreated
                         :is-searching="false"/>
                <BuyList :items="immediatelySaleList.filter(item=> item.Buy_Kind===1)"
                         v-if="immediatelySaleList && immediatelySaleList.length>0 &&
                                $store.state.roles.some(v=>['user_sell','admin','salemanager'].includes(v))"
                         title="فاکتورهای خرید اخیر"
                         :compact-view="true"
                         :read-only="true"
                         :filter="searchKey"
                         :no-price="true"
                         :no-order-info="true"
                         :is-dialog="false"
                         @sale-order-created=saleOrderCreated
                         :is-searching="false"/>
                <OrderList :order-trace="true" details-type="order"
                           @refresh-data="loadData"
                           :visitor-view="VisitorView"
                           :items="order_sale_statOptions"
                           :filter.sync="searchKey"
                           :can-make-factor="false"
                           :can-final-exit="false"
                           :default-open="!$q.screen.lt.md"
                           @change-order-state="changeOrderState"
                           header-class="bg-indigo-10 text-white"
                           title="1)تایید نهایی سفارش"
                           @full-screen="fullScreenSatge1Show"/>
                <OrderList :order-trace="true" details-type="order"
                           :items="order_sale_state_managerOptions"
                           :filter.sync="searchKey" :can-make-factor="false" :can-final-exit="false"
                           :default-open="!$q.screen.lt.md"
                           :visitor-view="VisitorView"
                           header-class="bg-indigo-10 text-white"
                           title="2)تایید مالی" @refresh-data="acceptFinanceCustomer"
                           :stage-order2="true"/>
                <OrderList
                    :visitor-view="VisitorView"
                    :order-trace="true" details-type="order" :items="before_stock_clerkOptions"
                    header-class="bg-indigo-10 text-white"
                    :filter.sync="searchKey"
                    :can-make-factor="false"
                    :can-final-exit="false"
                    :default-open="!$q.screen.lt.md"
                    title="3)صدور حواله"
                    :stage-order3="true"
                    @full-screen="fullScreenSatge3Show"
                    @refresh-data="loadData"/>
              </q-card-section>
            </q-card>
          </q-tab-panel>

          <q-tab-panel name="store" class="no-padding">
            <q-card flat>
              <q-card-section :horizontal="!$q.screen.lt.md" class="no-padding text-left">
                <OrderList :order-trace="false" details-type="hava" :allow-delete-hava="true"
                           :items="stock_clerkOptions.filter(item=>item.Co > 0)"
                           :visitor-view="VisitorView"
                           :filter.sync="searchKey" :can-make-factor="false" :can-final-exit="false"
                           :hava-actions="true" @refresh-data="loadData"
                           :default-open="!$q.screen.lt.md"
                           header-class="bg-indigo-10 text-white"
                           title="5)آماده سازی انباردار"
                           :can-set-drive="false"
                           :stage-number="4"
                           @full-screen="fullScreenSatge4Show"/>
                <OrderList :order-trace="false" details-type="hava" :allow-delete-hava="true"
                           :items="lodash.orderBy(stock_clerkOptions.filter(item=>item.Co===0 &&
                           !item.Transfer_Cost && item.NotSelectVisitor===0
                           && item.Sale_Kind===1), ['Cs_Name'],['asc'])"
                           :visitor-view="VisitorView"
                           :filter.sync="searchKey" :can-make-factor="false" :can-final-exit="false"
                           :hava-actions="true" @refresh-data="loadData"
                           :default-open="!$q.screen.lt.md"
                           header-class="bg-indigo-10 text-white"
                           v-if="$store.state.roles.some(v=>['admin','can_sea_order_trace','user_visitor'].includes(v))"
                           title="6)تعیین کرایه بار" :can-set-drive="true"/>
                <OrderList :order-trace="false" details-type="hava" :allow-delete-hava="true"
                           :items="lodash.orderBy(stock_clerkOptions.filter(item=>item.Co===0 && item.NotSelectVisitor===1 && item.Sale_Kind===1), ['Cs_Name'],['asc'])"
                           :filter.sync="searchKey" :can-make-factor="false" :can-final-exit="true"
                           :hava-actions="true" @refresh-data="loadData"
                           :default-open="!$q.screen.lt.md"
                           :visitor-view="VisitorView"
                           v-if="$store.state.roles.some(v=>['admin','can_sea_order_trace','user_visitor'].includes(v))"
                           header-class="bg-indigo-10 text-white"
                           title="7)تاییدیه خروج" :can-set-drive="true"/>
              </q-card-section>
            </q-card>
          </q-tab-panel>

          <q-tab-panel name="factor" class="no-padding">
            <q-card flat>
              <q-card-section :horizontal="!$q.screen.lt.md" class="no-padding text-left">
                <OrderList :order-trace="false" :hava-actions="true" :allow-delete-hava="true"
                           details-type="hava"
                           :items="order_exitOptions" :filter.sync="searchKey" :can-make-factor="true"
                           :default-open="true"
                           :can-set-drive="false"
                           header-class="bg-indigo-10 text-white"
                           :visitor-view="VisitorView"
                           title="8)صدور فاکتور فروش" @refresh-data="loadData"/>
                <WayBillList :filter.sync="searchKey" title="9) صدور و رهگیری بارنامه"
                             :items="wayBillOptions"
                             :available-items="order_exitOptions.map(a => Object.assign({}, a))"
                             :show-all="false"
                             @filtered="wayBillFiltered"
                             :driver-grouped-info="driverGroupedInfo"
                             v-if="VisitorView===false || $store.state.roles.some(v=>['user_store'].includes(v))"
                             :visitor-view="VisitorView"
                             @issue-finance-document="issueFinanceDocument"
                             @pay-finance-document="payFinanceDocument"
                             @refresh-data="removeWallBillNumber"/>
                <OrderList :order-trace="false" :hava-actions="false" details-type="factor"
                           :items="factorListOptions"
                           :filter.sync="searchKey" :can-make-factor="false"
                           :default-open="true"
                           :has-attachment=true
                           v-if="$store.state.roles.some(v=>['admin','can_sea_order_trace','user_visitor'].includes(v))"
                           header-class="bg-indigo-10 text-white"
                           title="10)صدور سند مالی" :finance-service-status="financeServiceStatus"
                           :visitor-view="VisitorView"
                           @start-issue-finance="startIssueFinance"
                           @stop-issue-finance="stopIssueFinance"
                           @issue-finance-success="issueFinanceSuccess"
                           @attachment_removed="attachmentRemoved"
                           @attachment-uploaded="attachmentUploaded"
                />
              </q-card-section>
            </q-card>
          </q-tab-panel>
        </q-tab-panels>
      </q-card-section>
    </q-card>

    <q-dialog :maximized="$q.screen.lt.md" v-model="orderTraceFilterDialog">
      <OrderTraceFilterEditor :input-companies.sync="filterInfo.selectedCompanies"
                              :input-states.sync="filterInfo.selectedStates"
                              :input-cities.sync="filterInfo.selectedCities"
                              :input-goods-group="filterInfo.selectedGoodsGroup"
                              :input-goods="filterInfo.selectedGoods"
                              @apply-filter="applyFilter"/>
    </q-dialog>
    <q-dialog v-model="fullScreenSatge1" maximized>
      <OrderList :order-trace="true" details-type="order" @refresh-data="loadData" :items="order_sale_statOptions"
                 :filter.sync="searchKey" :can-make-factor="false" :can-final-exit="false"
                 :default-open="!$q.screen.lt.md"
                 header-class="bg-indigo-8 text-white" :stage-number="1"
                 :visitor-view="VisitorView"
                 title="1)تایید نهایی سفارش" :full-screen="true"/>
    </q-dialog>
    <q-dialog v-model="fullScreenSatge3" maximized>
      <OrderList
          :order-trace="true" details-type="order" :items="before_stock_clerkOptions"
          header-class="bg-indigo-10 text-white"
          :filter.sync="searchKey" :can-make-factor="false" :can-final-exit="false"
          :default-open="!$q.screen.lt.md" :stage-number="3" :full-screen="true"
          :visitor-view="VisitorView"
          title="3)صدور حواله" :stage-order3="true" @refresh-data="loadData"/>
    </q-dialog>
    <q-dialog v-model="fullScreenSatge4" maximized>
      <OrderList :order-trace="false" details-type="hava" :allow-delete-hava="true"
                 :items="stock_clerkOptions.filter(item=>item.Co > 0)"
                 :filter.sync="searchKey" :can-make-factor="false" :can-final-exit="false"
                 :hava-actions="true" @refresh-data="loadData"
                 :default-open="!$q.screen.lt.md"
                 header-class="bg-brown-5 text-white"
                 :stage-number="4"
                 :full-screen="true"
                 :visitor-view="VisitorView"
                 title="4)آماده سازی انباردار" :can-set-drive="false"/>
    </q-dialog>
  </q-pull-to-refresh>
</template>

<script>
import OrderList from "@/components/OrderTrace/OrderList";
import {mapActions} from "vuex";
import WayBillList from "@/components/WayBill/WayBillList";
import OrderTraceFilterEditor from "@/components/OrderTrace/OrderTraceFilterEditor";
import Summary from "@/components/OrderTrace/Summary";
import BuyList from "@/components/Buys/BuyList.vue";

export default {
  name: "OrderTrace",
  components: {BuyList, Summary, OrderTraceFilterEditor, WayBillList, OrderList},
  props: {
    adminView: {
      type: Boolean,
      default: false
    },
    VisitorView: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      tab: this.$store.state.roles.some(v => ['admin', 'can_sea_order_trace', 'user_visitor'].includes(v)) ? 'order' : 'store',
      fullScreenSatge1: false,
      fullScreenSatge3: false,
      fullScreenSatge4: false,
      filterInfo: {
        selectedCompanies: null,
        selectedStates: null,
        selectedCities: null,
        selectedGoodsGroup: null,
        selectedGoods: null
      },
      expired: false,
      orderTraceFilterDialog: false,
      searchKey: '',
      archive: false,
      needForDelete: false,
      order_sale_stat: [],
      order_sale_state_manager: [],
      before_stock_clerk: [],
      stock_clerk: [],
      order_exit: [],
      factorList: [],
      buyRequestList: [],
      finalPrepareInStore: false,
      order_sale_statOptions: [],
      order_sale_state_managerOptions: [],
      before_stock_clerkOptions: [],
      stock_clerkOptions: [],
      order_exitOptions: [],
      factorListOptions: [],
      financeServiceStatus: false,
      companyList: [],
      wayBill: [],
      wayBillOptions: [],
      orderPrepared: [],
      summary: [],
      sale_velocity: [],
      totalSalesInfo: {
        Sale_Pay: 0,
        salePrice: 0
      },
      immediatelySaleList: [],
      newCustomerList: [],
      driverGroupedInfo: []
    }
  },
  methods: {
    ...mapActions({
      getOrderTrace: 'Orders/getOrderTraceLists',
      getFinanceServiceStatus: 'Requests/getFinanceServiceStatus',
      getBuyOrderTrace: 'Buys/getOrderTraceList',
      getBalance: 'Finnotech/getBalance',
      getWalletInfo: 'Finnotech/getWallet'
    }),
    acceptFinanceCustomer(arg) {
      const founded = this.order_sale_state_managerOptions.filter(item => item.Sale_Num === arg.Sale_Num)
      if (founded) {
        founded[0].Sale_StateModir = 1
        founded[0].Sale_UserIDModir = this.$store.state.userId

        this.order_sale_state_managerOptions = this.order_sale_state_managerOptions.filter(item => item.Sale_Num !== arg.Sale_Num)
        this.before_stock_clerkOptions.unshift(founded[0])
      }
    },
    wayBillFiltered(args) {
      if (args === undefined) {
        this.wayBillOptions = this.wayBill
      } else {
        this.wayBillOptions = this.wayBill.filter(item => item.Visitor_ID === args)
      }
    },
    issueFinanceDocument(args) {
      const foundedIndex = this.wayBill.findIndex(x => x.WayBillNumber === parseInt(args))
      this.wayBill[foundedIndex].HasFinanceDocument = true

      const foundedIndexOptions = this.wayBillOptions.findIndex(x => x.WayBillNumber === parseInt(args))
      this.wayBillOptions[foundedIndexOptions].HasFinanceDocument = true

    },
    payFinanceDocument(args) {
      const foundedIndex = this.wayBill.findIndex(x => x.WayBillNumber === parseInt(args))
      this.wayBill[foundedIndex].IsPay = true

      const foundedIndexOptions = this.wayBillOptions.findIndex(x => x.WayBillNumber === parseInt(args))
      this.wayBillOptions[foundedIndexOptions].IsPay = true

    },
    attachmentRemoved(args) {
      const searchIndex = this.factorList.findIndex((item) => item.Sale_Num === args.Sale_Num && item.Sale_Kind === args.Sale_Kind);
      this.factorList[searchIndex].HasAttachment = false

      const searchIndexOptions = this.factorListOptions.findIndex((item) => item.Sale_Num === args.Sale_Num && item.Sale_Kind === args.Sale_Kind);
      this.factorListOptions[searchIndexOptions].HasAttachment = false

    },
    attachmentUploaded(args) {
      if ('filename' in args) {
        const searchIndex = this.factorList.findIndex((item) => item.Sale_Num === parseInt(args.filename) && item.Sale_Kind === args.fileKind);
        this.factorList[searchIndex].HasAttachment = true

        const searchIndexOptions = this.factorListOptions.findIndex((item) => item.Sale_Num === parseInt(args.filename) && item.Sale_Kind === args.fileKind);
        this.factorListOptions[searchIndexOptions].HasAttachment = true
      }
    },
    saleOrderCreated(args) {
      this.order_sale_statOptions.unshift(args)
    },
    removeWallBillNumber(args) {
      const index = this.wayBillOptions.findIndex(item => {
        return (item.WayBillNumber === args)
      })
      this.$delete(this.wayBillOptions, index)
    },
    startIssueFinance(args) {
      args.isProcess = true
      const founded = this.factorList.filter(item => item.Sale_Num === args.Sale_Num && item.Sale_Kind === args.Sale_Kind)
      if (founded && founded.length > 0) {
        founded[0].isProcess = true
      }
      const foundedOptions = this.factorListOptions.filter(item => item.Sale_Num === args.Sale_Num && item.Sale_Kind === args.Sale_Kind)
      if (foundedOptions && foundedOptions.length > 0) {
        foundedOptions[0].isProcess = true
      }
    },
    stopIssueFinance(args) {
      const founded = this.factorList.filter(item => item.Sale_Num === args.Sale_Num && item.Sale_Kind === args.Sale_Kind)
      if (founded && founded.length > 0) {
        founded[0].isProcess = false
      }
      const foundedOptions = this.factorListOptions.filter(item => item.Sale_Num === args.Sale_Num && item.Sale_Kind === args.Sale_Kind)
      if (foundedOptions && foundedOptions.length > 0) {
        foundedOptions[0].isProcess = false
      }
    },
    issueFinanceSuccess(args) {
      const index = this.factorList.findIndex(item => {
        return (args.Sale_Num === item.Sale_Num && args.Sale_Kind === item.Sale_Kind)
      })
      this.$delete(this.factorList, index)

      const indexOptions = this.factorListOptions.findIndex(item => {
        return (args.Sale_Num === item.Sale_Num && args.Sale_Kind === item.Sale_Kind)
      })
      this.$delete(this.factorListOptions, indexOptions)
    },
    changeOrderState(args) {
      const foundedIndex = this.order_sale_statOptions.findIndex(item => {
        return (item.Sale_Num === args.data.Sale_Num)
      })
      this.$delete(this.order_sale_statOptions, foundedIndex)
      args.data.Sale_State = args.state
      this.order_sale_state_managerOptions.push(args.data)
    },
    fullScreenSatge1Show() {
      this.fullScreenSatge1 = true
    },
    fullScreenSatge3Show() {
      this.fullScreenSatge3 = true
    },
    fullScreenSatge4Show() {
      this.fullScreenSatge4 = true

    },
    showFullScreen() {
    },
    showFilterDialog() {
      this.orderTraceFilterDialog = true
    },
    initialize() {
      this.order_sale_statOptions = this.order_sale_stat
      this.order_sale_state_managerOptions = this.order_sale_state_manager
      this.stock_clerkOptions = this.stock_clerk
      this.order_exitOptions = this.order_exit
      this.before_stock_clerkOptions = this.before_stock_clerk
      this.factorListOptions = this.factorList
    },
    citySelected(args) {
      this.applyFilter({selectedCities: args})
    },
    applyFilter(arg) {
      this.filterInfo.selectedCompanies = arg.selectedCompanies === null || arg.selectedCompanies === undefined ? [] : arg.selectedCompanies
      this.filterInfo.selectedStates = arg.selectedStates === null || arg.selectedStates === undefined ? [] : arg.selectedStates
      this.filterInfo.selectedCities = arg.selectedCities === null || arg.selectedCities === undefined ? [] : arg.selectedCities
      this.filterInfo.selectedGoodsGroup = arg.selectedGoodsGroup === null || arg.selectedGoodsGroup === undefined ? [] : arg.selectedGoodsGroup
      this.filterInfo.selectedGoods = arg.selectedGoods === null || arg.selectedGoods === undefined ? [] : arg.selectedGoods


      let comIDs = this.filterInfo.selectedCompanies.map(record => record.CompID)
      let stateIDs = this.filterInfo.selectedStates.map(record => record.State_ID)
      let cityIDs = this.filterInfo.selectedCities.map(record => record.City_ID)
      let goodsGroupIDs = this.filterInfo.selectedGoodsGroup.map(record => record.Group_ID)
      let goodsIDs = this.filterInfo.selectedGoods.map(record => record.Goods_ID)


      this.order_sale_statOptions =
          this.order_sale_stat.filter(item =>
              (comIDs.includes(item.CompID) || comIDs.length === 0) &&
              (stateIDs.includes(item.CsState_ID) || stateIDs.length === 0) &&
              (cityIDs.includes(item.CsCity_ID) || cityIDs.length === 0) &&
              (item.GoodsGroup && this.lodash.intersection([...new Set(JSON.parse(item.GoodsGroup).map(c => c.Goods_Group))], goodsGroupIDs).length > 0 || goodsGroupIDs.length === 0) &&
              (item.GoodsGroup && this.lodash.intersection([...new Set(JSON.parse(item.GoodsGroup).map(c => c.Goods_ID))], goodsIDs).length > 0 || goodsIDs.length === 0)
          )

      this.order_sale_state_managerOptions =
          this.order_sale_state_manager.filter(item =>
              (comIDs.includes(item.CompID) || comIDs.length === 0) &&
              (stateIDs.includes(item.CsState_ID) || stateIDs.length === 0) &&
              (cityIDs.includes(item.CsCity_ID) || cityIDs.length === 0) &&
              (item.GoodsGroup && this.lodash.intersection([...new Set(JSON.parse(item.GoodsGroup).map(c => c.Goods_Group))], goodsGroupIDs).length > 0 || goodsGroupIDs.length === 0) &&
              (item.GoodsGroup && this.lodash.intersection([...new Set(JSON.parse(item.GoodsGroup).map(c => c.Goods_ID))], goodsIDs).length > 0 || goodsIDs.length === 0)
          )

      this.stock_clerkOptions =
          this.stock_clerk.filter(item =>
              (comIDs.includes(item.CompID) || comIDs.length === 0) &&
              (stateIDs.includes(item.CsState_ID) || stateIDs.length === 0) &&
              (cityIDs.includes(item.CsCity_ID) || cityIDs.length === 0) &&
              (item.GoodsGroup && this.lodash.intersection([...new Set(JSON.parse(item.GoodsGroup).map(c => c.Goods_Group))], goodsGroupIDs).length > 0 || goodsGroupIDs.length === 0) &&
              (item.GoodsGroup && this.lodash.intersection([...new Set(JSON.parse(item.GoodsGroup).map(c => c.Goods_ID))], goodsIDs).length > 0 || goodsIDs.length === 0)
          )

      this.order_exitOptions =
          this.order_exit.filter(item =>
              (comIDs.includes(item.CompID) || comIDs.length === 0) &&
              (stateIDs.includes(item.CsState_ID) || stateIDs.length === 0) &&
              (cityIDs.includes(item.CsCity_ID) || cityIDs.length === 0) &&
              (item.GoodsGroup && this.lodash.intersection([...new Set(JSON.parse(item.GoodsGroup).map(c => c.Goods_Group))], goodsGroupIDs).length > 0 || goodsGroupIDs.length === 0) &&
              (item.GoodsGroup && this.lodash.intersection([...new Set(JSON.parse(item.GoodsGroup).map(c => c.Goods_ID))], goodsIDs).length > 0 || goodsIDs.length === 0)
          )

      this.before_stock_clerkOptions =
          this.before_stock_clerk.filter(item =>
              (comIDs.includes(item.CompID) || comIDs.length === 0) &&
              (stateIDs.includes(item.CsState_ID) || stateIDs.length === 0) &&
              (cityIDs.includes(item.CsCity_ID) || cityIDs.length === 0) &&
              (item.GoodsGroup && this.lodash.intersection([...new Set(JSON.parse(item.GoodsGroup).map(c => c.Goods_Group))], goodsGroupIDs).length > 0 || goodsGroupIDs.length === 0) &&
              (item.GoodsGroup && this.lodash.intersection([...new Set(JSON.parse(item.GoodsGroup).map(c => c.Goods_ID))], goodsIDs).length > 0 || goodsIDs.length === 0)
          )

      this.factorListOptions =
          this.factorList.filter(item =>
              (comIDs.includes(item.CompID) || comIDs.length === 0) &&
              (stateIDs.includes(item.CsState_ID) || stateIDs.length === 0) &&
              (cityIDs.includes(item.CsCity_ID) || cityIDs.length === 0) &&
              (item.GoodsGroup && this.lodash.intersection([...new Set(JSON.parse(item.GoodsGroup).map(c => c.Goods_Group))], goodsGroupIDs).length > 0 || goodsGroupIDs.length === 0) &&
              (item.GoodsGroup && this.lodash.intersection([...new Set(JSON.parse(item.GoodsGroup).map(c => c.Goods_ID))], goodsIDs).length > 0 || goodsIDs.length === 0)
          )
    },
    refresh(done) {
      setTimeout(async () => {
        await this.loadData()
        done()
      }, 1000)
    },
    async loadData(arg) {
      if (arg) {
        if (arg.type === 'factor') {
          this.factorList = this.factorList.filter(item => item.Sale_Num !== arg.saleNum)
          this.factorListOptions = this.factorListOptions.filter(item => item.Sale_Num !== arg.saleNum)
        } else if (arg.type === 'trace') {
          console.log(arg)
        } else if (arg.type === 6) {
          this.stock_clerk = this.stock_clerk.filter(item => item.Sale_Num !== arg.rowInfo.Sale_Num)
          this.stock_clerkOptions = this.stock_clerkOptions.filter(item => item.Sale_Num !== arg.rowInfo.Sale_Num)
          arg.rowInfo.Sale_State = 1
          arg.rowInfo.LastTraceinfo = 'تاییدیه تحویل به طرف معامله'
          arg.rowInfo.ReasonDescription = 'اقلام حواله آماده سازی و حواله برای تحویل به طرف معامله مورد تایید است'
          this.order_exit.push(arg.rowInfo)
          this.order_exitOptions.push(arg.rowInfo)
        }
      } else {
        await Promise.all([
          // this.getWalletInfo("WayBillWallet").then((res) => {
          //   this.$store.state.balanceInfo = res.effectiveBalance
          // }),
          this.getFinanceServiceStatus().then((res) => {
            if (res.result === '101') {
              this.financeServiceStatus = true;
              this.$store.state.financeServiceStatus = true;
            }
          }),
          this.getOrderTrace({
            archive: this.archive === true ? 1 : 0,
            expired: this.expired === true ? 1 : 0,
          }).then((res) => {
            this.order_sale_stat = JSON.parse(res.data.saleState);
            this.order_sale_statOptions = this.order_sale_stat

            this.order_sale_state_manager = JSON.parse(res.data.managerSaleState);
            this.order_sale_state_managerOptions = this.order_sale_state_manager

            this.stock_clerk = JSON.parse(res.data.stockClerk);
            this.stock_clerkOptions = this.stock_clerk

            this.order_exit = JSON.parse(res.data.order_exit);
            this.order_exitOptions = this.order_exit

            this.before_stock_clerk = JSON.parse(res.data.beforeStockClerk);
            this.before_stock_clerkOptions = this.before_stock_clerk

            this.factorList = JSON.parse(res.data.Factor);
            this.factorListOptions = this.factorList

            if (res.data.buyRequest) {
              this.buyRequestList = JSON.parse(res.data.buyRequest)
            } else {
              this.buyRequestList = []
            }
            this.newCustomerList = JSON.parse(res.data.newCustomer)
            this.wayBill = JSON.parse(res.data.WayBill.replaceAll('None', "''"));
            this.wayBill.forEach((record) => {
              if (record.Sale_Nums) {
                record.Sale_Nums = JSON.parse(record.Sale_Nums)
              }
            })
            this.wayBillOptions = this.wayBill;
            this.driverGroupedInfo = this.lodash(this.wayBillOptions).groupBy('Visitor_Name').map(arr => {
              const {Visitor_ID, Visitor_Name} = arr[0]
              return {
                Visitor_ID,
                Visitor_Name,
                totalCost: this.lodash(arr).sumBy(item => item.TransferCost)
              };
            }).value()
            this.orderPrepared = this.stock_clerkOptions.filter(item => item.Co === 0 && item.Visitor_Name);
            if ('TotalSales' in res.data) {
              if (JSON.parse(res.data.TotalSales).length > 0) {
                this.totalSalesInfo.Sale_Pay = JSON.parse(res.data.TotalSales)[0].Sale_Pay
              }
            }
            this.totalSalesInfo.salePrice = JSON.parse(res.data.TotalSales).length > 0 ? JSON.parse(res.data.TotalSales)[0].salePrice : 0;
            this.applyFilter({
              selectedCompanies: this.filterInfo.selectedCompanies,
              selectedStates: this.filterInfo.selectedStates,
              selectedCities: this.filterInfo.selectedCities
            })
            this.summary = JSON.parse(res.data.OrderTraceSummary)
            this.immediatelySaleList = JSON.parse(res.data.ImmediatelySaleList)
            if (res.data.sale_velocity) {
              this.sale_velocity = JSON.parse(res.data.sale_velocity)
            }

            this.$store.state.profitInfo = JSON.parse(res.data.profit)[0]

            this.factorList.forEach((res) => {
              res.isProcess = false
            })
            this.factorListOptions.forEach((res) => {
              res.isProcess = false
            })
          })
        ])
      }
    },
  },
  watch: {
    archive: function () {
      this.loadData()
    },
    expired: function () {
      this.loadData()
    },
    needForDelete: function (value) {
      if (value) {
        this.order_sale_statOptions = this.order_sale_stat.filter(item => item.LastTraceinfo === 'حذف');
        this.order_sale_state_managerOptions = this.order_sale_state_manager.filter(item => item.LastTraceinfo === 'حذف')
        this.stock_clerkOptions = this.stock_clerk.filter(item => item.LastTraceinfo === 'حذف')
        this.order_exitOptions = this.order_exit.filter(item => item.LastTraceinfo === 'حذف')
        this.before_stock_clerkOptions = this.before_stock_clerk.filter(item => item.LastTraceinfo === 'حذف')
        this.factorListOptions = this.factorList.filter(item => item.LastTraceinfo === 'حذف')
      } else {
        this.order_sale_statOptions = this.order_sale_stat;
        this.order_sale_state_managerOptions = this.order_sale_state_manager
        this.stock_clerkOptions = this.stock_clerk
        this.order_exitOptions = this.order_exit
        this.before_stock_clerkOptions = this.before_stock_clerk
        this.factorListOptions = this.factorList
      }
    },
    finalPrepareInStore: function (value) {
      if (value) {
        this.stock_clerkOptions = this.stock_clerk.filter(item => item.Co === 0 && item.Visitor_Name)
      } else {
        this.stock_clerkOptions = this.stock_clerk
      }
    }
  },
  computed: {
    filterButtonColor: function () {
      let Companies = this.filterInfo.selectedCompanies !== null && this.filterInfo.selectedCompanies.length > 0
      let Cities = this.filterInfo.selectedCities !== null && this.filterInfo.selectedCities.length > 0
      let States = this.filterInfo.selectedStates !== null && this.filterInfo.selectedStates.length > 0
      let Goods = this.filterInfo.selectedGoods !== null && this.filterInfo.selectedGoods.length > 0
      let goodsGroup = this.filterInfo.selectedGoodsGroup !== null && this.filterInfo.selectedGoodsGroup.length > 0

      return Companies || Cities || States || Goods || goodsGroup ? 'deep-orange' : ''
    }
  },
  created() {
    this.loadData();
    this.getBuyOrderTrace().then((res) => {
      this.buyItems = res
    })
    setInterval(() => {
      this.loadData()
    }, 600000);
  }
}
</script>

<style scoped>
.my-class > td:before {
  background: rgba(0, 0, 0, 0) !important;
}
</style>
